import API from "components/Apis/API"
import toast from "react-hot-toast"

export const updateCheckedField = async (id, value, shift) => {
    const url = "admin/briefing/update_text_field";
    let formData = new FormData();
    formData.append("id", id);
    formData.append("value", value);
    formData.append("shift", shift);
    let data = {};
    try {
        const response = await API.postData(url, formData);
        data = response;
        toast.success("Update Success")
    }
    catch {
        data = []
    }
    return data;
};

export const updateTextField = async (id, value, shift) => {
    const url = "admin/briefing/update_text_field";
    let formData = new FormData();
    formData.append("id", id);
    formData.append("value", value);
    formData.append("shift", shift);
    let data = {};
    try {
        const response = await API.postData(url, formData);
        data = response;
        toast.success("Update Success")
    }
    catch {
        data = []
        toast.error("Update Failed")
    }
    return data;
};

export const CRUDRow = async (url, action, rowID) => {
    const formData = new FormData();
    formData.append("action", action);
    formData.append("rowID", rowID);
    let data = {};
    try {
        // Send the POST request to the server
        const response = await API.postData(url, formData);
        data = response;
        if (response.status == 200) {
            toast.success("Operation Completed!")
        }
        else if (response.status == 403) {
            toast.error("Row has been edited!")
        }
        else {
            throw (`CRUD row failed ${url}`)
        }
    } catch (error) {
        // Handle errors gracefully and log the error for debugging
        toast.error("Operation Failed!")
    }
    return data;  // Return the result or error information
};

export function translateFieldShiftFlag(shiftFlag) {
    let future_shift = null;
    if (shiftFlag === 0) {
        future_shift = "first"
    }
    if (shiftFlag === 1) {
        future_shift = "second"
    }
    if (shiftFlag === 2) {
        future_shift = "third"
    }
    return future_shift
}

export function getFieldShiftFlag(shift) {
    let shiftFlag = null;
    if (shift === "first") {
        shiftFlag = 0
    }
    if (shift === "second") {
        shiftFlag = 1
    }
    if (shift === "third") {
        shiftFlag = 2
    }
    return shiftFlag
}

export const fetchRows = async (url, briefing, requestPayload = null, option = "data") => {
    let formData = new FormData();
    
    // Set archive based on briefing state
    let archive = "False";
    if (briefing === 'Old Briefings') {
        archive = "True";
    }

    if (requestPayload) {
        for (let key in requestPayload) {
            if (requestPayload.hasOwnProperty(key)) {  // Check if the key is an own property
                formData.append(key, requestPayload[key]);
            }
        }
    }

    let data = {};
    try {
        const response = await API.postData(`${url}/${archive}/${option}`, formData);
        data = response.data;
    } catch {
        data = [];
    }
    return data;
};


export const fetchRPMDocumentBlob = async (event) => {
    try {
        const url = "admin/briefing/get_rpm_document";  // The API endpoint
        let formData = new FormData();  // Empty form data (or add any necessary form fields)

        const blob = await API.postData(url, formData, true);

        const blobUrl = window.URL.createObjectURL(blob);

        // Create a link element, set its href to the blob URL, and click it to open the PDF
        const link = document.createElement('a');
        link.href = blobUrl;
        link.target = '_blank'; // Open in a new tab
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        // Log the error for debugging purposes
        console.error('Error during fetch:', error);
        return null;
    }
};

export const fetchBriefingDocument = async (id) => {
    try {
        const url = "admin/briefing/get_briefing_document";  // The API endpoint
        let formData = new FormData();  // Empty form data (or add any necessary form fields)

        formData.append('id', id);

        const blob = await API.postData(url, formData, true);

        const blobUrl = window.URL.createObjectURL(blob);

        // Create a link element, set its href to the blob URL, and click it to open the PDF
        const link = document.createElement('a');
        link.href = blobUrl;
        link.target = '_blank'; // Open in a new tab
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        // Log the error for debugging purposes
        console.error('Error during fetch:', error);
        return null;
    }
};

export function uploadBriefingDocument(event, url, id) {
    const formData = new FormData();

    try {
        const validTypes = ['application/pdf'];
        const file = event.target.files[0];
        if (!validTypes.includes(file.type)) {
            toast.error("Invalid file type.");
            return;
        }

        formData.append('document', file);
        formData.append('rowID', id);
        formData.append('action', 'attachment');


        API.postData(url, formData)
            .then(response => {
                if (response.status) {
                    toast.success("Document Uploaded!");
                } else {
                    throw new Error("Upload failed");
                }
            })
    } catch (error) {
        toast.error("Upload Failed!");
    }
}

export const FLOAT_INPUT_FIELD_FILTER = {
    filter: (targetValue) => /^[0-9.-]*$/.test(targetValue),
    message: "This field accepts floats only"
}

export const INT_INPUT_FIELD_FILTER = {
    filter: (targetValue) => /^[0-9-]*$/.test(targetValue),  // Allow only digits and minus sign
    message: "This field accepts integers only"
}

export function getDeltaDayFormattedDate(deltaDay) {
    // Get today's date
    const today = new Date();
    // Subtract deltaDay from today's date
    today.setDate(today.getDate() - deltaDay);
    // Format the date in YYYY-MM-DD format
    const formattedDate = today.toISOString().split('T')[0];
    return formattedDate;
  }
  